import { Box, Grid, LinearProgress, Tab, Tabs, Tooltip, Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Fab from '@material-ui/core/Fab'
import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import { createMuiTheme, makeStyles, ThemeProvider, withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'
import CloseIcon from '@material-ui/icons/Close'
import ForumIcon from '@material-ui/icons/ForumOutlined'
import axios from 'axios'
import moment from 'moment'
import React, { Component, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useHistory, withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import {
  getAgentInfo,
  getCardEnableData,
  getClientDetails,
  getEncryptData,
  getEnrolledMemberData,
  getEnrollMemberInfoById,
  gethealthcard,
  getProgramInfo,
  getRxSimpleShareData,
  getSourceID
} from '../../ApiCall'
import CommonLoader from '../../CommonLoader'
import MobCopyright from '../../MobileScreen/MobCopyright'
import MobileFooter from '../../MobileScreen/MobileFooter'
// import '../../MobileScreen/MobileFooter.css'
import ChatIcon from '../ChatBox/ChatIcon'
import CommonFooter from '../CommonFooter'
import Header from '../Header'
import customStyle from './CSS/stylesheet_UHS'
import i18n from './i18next'
import './ProgramInformation.css'
import Modal1 from 'react-awesome-modal'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'

const CrudButton = withStyles(customStyle.crudBtn)(Fab)
const NextButton = withStyles(customStyle.ChangePayButton)(Button)

window.mobileAndTabletCheck = function() {
  let check = false
  ;(function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)
  return check
}

const TableHeadCell = withStyles({
  root: {
    borderBottom: 'none',
    padding: '8px',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 'normal',

    letterSpacing: '1.12px',
    textAlign: 'left',
    color: '#454d58'
  }
})(TableCell)

const TableBodyCell = withStyles({
  root: {
    borderBottom: 'none',
    padding: '8px',
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: '500',

    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000'
  }
})(TableCell)

const AntTabs = withStyles(customStyle.ProgTabs)(Tabs)
// const NextButton = withStyles(customStyle.PayButton)(Button)
class ProgramInformation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loader: false,
      sampleData: sampleData,
      barRange: '0',
      barRangeYellow: '0',
      acsmTotal: '',
      acsmmet: '',
      acsmremain: '',
      nsamet: '',
      nsaremain: '',
      programname: '',
      programname2: '',
      showwithacsm: false,
      clientID: '',
      associationId: '',
      clientName: '',
      brokerId: '',
      subID: '',
      healthToolAddonActive: false,
      rxSimpleShareActive: false,
      reviveAddonActive:false,
      addOnsObj: [],
      counterHealthTool: 0,
      counterRxSimpleShare: 0,
      counterRevive:0,
      enrolledDataMember: [],
      selectedTab:"summary",
      profileAnchorEl: null,
      profileMenuOpen: false,
      openProfileSettings: false,
      accumulator:{}
    }
  }

  format = n => {
    n = Math.round(Number(n));   // round off
    return n.toLocaleString();
  };

  componentDidMount() {
    this.setState({
      loader: true
    })
    this.getCardEnable()
    this.getAddonsData()
    this.getEnrolledMemberData()
    getProgramInfo()
      .then(res => {
        if (res.data && res.data.programInfo) {
          this.setState({
            programInfo: res.data.programInfo,
            eligibleServices: res.data.planInfo,
            expenseLimits: res.data.expenseLimits,
            accumulator : res.data.accumulator
          })

          let clientId = {
            clientId: localStorage.getItem('CLIENT_ID')
          }
          getClientDetails(clientId).then(response => {
            if (response.data.response) {
             this.setState(
                {
                  clientID: response.data.response.clientId,
                  associationId: response.data.response.association,
                  clientName: response.data.response.clientName
                },
                () => {
                  if (localStorage.getItem('SOURCE') !== 'NEO') {
                    this.getSourceIDbyemail()
                  }
                }
              )
            }
          })
          let programName = res.data.programInfo.programName
          var str = res.data.programInfo.programName
          if (str.includes('+')) {
            var str1 = res.data.programInfo.programName
            var res1 = str1.split(' ')
            this.setState({ programname: res1[0], programname2: ' with ' + res1[2], showwithacsm: true })
            programName = res1[0] + ' with ' + res1[2]
          } else {
            this.setState({ programname: res.data.programInfo.programName, showwithacsm: false })
            programName =  res.data.programInfo.programName
          }
          let EMPID = localStorage.getItem('Member_EMPID')
          const numericEmpId = EMPID.replace(/\D/g, ""); // 327048

          const matchedMember = res?.data?.accumulator?.memberAccumsDetails.find(
            item => item.empId === numericEmpId
          );

          const data = [
            {
              label: "Your Current Program",
              value: programName || '-'
            },
            (matchedMember?.nsaAccumsDetails.totalNsaAmount || res?.data?.accumulator?.memberAccumsDetails[0]?.nsaAccumsDetails.totalNsaAmount) && {
              label: "Your Personal Responsibility (Non-Sharable Amount / NSA) — Per Member Met",
              value: (
                <>
                  ${this.format( matchedMember?.nsaAccumsDetails.usedNSAMet ? matchedMember?.nsaAccumsDetails.usedNSAMet : res?.data?.accumulator?.memberAccumsDetails[0]?.nsaAccumsDetails.usedNSAMet)}
                  <span style={{ fontSize: '12px', color: '#888' }}> met / </span>
                  ${this.format( matchedMember?.nsaAccumsDetails.remainingNSAAmount ? matchedMember?.nsaAccumsDetails.remainingNSAAmount : res?.data?.accumulator?.memberAccumsDetails[0]?.nsaAccumsDetails.remainingNSAAmount)}
                  <span style={{ fontSize: '12px', color: '#888' }}> remaining</span>
                </>
              ),
              tooltip:
                'The amount you are responsible for paying before UHF shares in your medical costs.'
            },
            res?.data?.accumulator?.familyAccumsDetails.nsaAccumsDetails.totalNsaAmount && {
              label: "Your Family's Total Responsibility (Non-Sharable Amount / NSA) — Per Household",
              value: (
                <>
                  ${this.format(res.data.accumulator.familyAccumsDetails.nsaAccumsDetails.usedNSAMet)}
                  <span style={{ fontSize: '12px', color: '#888' }}> met / </span>
                  ${this.format(res.data.accumulator.familyAccumsDetails.nsaAccumsDetails.remainingNSAAmount)}
                  <span style={{ fontSize: '12px', color: '#888' }}> remaining</span>
                </>
              ),
              tooltip:
                'The total your household pays before UHF begins sharing, regardless of how many members have expenses.'
            },
            (() => {
              const value = this.getFieldValueById(
                res?.data?.expenseLimits,
                'Medical Incident Sharing Limit'
              );
               // Don't render if targetId doesn't exist
              if (value === null) return null;
              return {
                label:
                  'Max Sharing Per Illness or Injury (Sharable Amount Limit Per Medical Incident)',
                value,
                tooltip:
                  'UHF will share up to this amount for any single medical incident, such as a surgery or hospitalization.'
              };
            })(),
            (() => {
              const value = this.getFieldValueById(
                res?.data?.expenseLimits,
                'Annual Sharing Limit'
              );
               // Don't render if targetId doesn't exist
              if (value === null) return null;
              return {
                label:
                  'Max Sharing Per Person Per Year (Annual Sharing Maximum Per Member)',
                value,
                tooltip:
                  "The most UHF will share for one member's medical expenses within a single program year (effective date to effective date)."
              };
            })(),
            res?.data?.annualCoShareMaximum && {
              label: 'Annual Co-Share Maximum (ACSM)',
              value: `$${this.format(res.data.annualCoShareMaximum)}`,
              tooltip:
                "After meeting your Personal Responsibility Amount (NSA), you and the sharing community split eligible costs. The Annual Co-Share Maximum caps what you'll pay in that split for the year. Once you reach it, your eligible expenses are shared at 100% for the rest of your program year."
            }
          ].filter(Boolean);
          this.setState({programData:data})
         
          var percentascm = res.data.accumulator.familyAccumsDetails.acsmAccumsDetails.totalACSMAmount ? (res.data.accumulator.familyAccumsDetails.acsmAccumsDetails.usedACSMMet / res.data.accumulator.familyAccumsDetails.acsmAccumsDetails.totalACSMAmount) * 100 : 0;

          var percentnsa = res.data.accumulator.familyAccumsDetails.nsaAccumsDetails.totalNsaAmount ? (res.data.accumulator.familyAccumsDetails.nsaAccumsDetails.usedNSAMet / res.data.accumulator.familyAccumsDetails.nsaAccumsDetails.totalNsaAmount) * 100 : 0;

          this.setState({
            acsmmet: res.data.accumulator.familyAccumsDetails.acsmAccumsDetails.usedACSMMet,
            acsmTotal: res.data.accumulator.familyAccumsDetails.acsmAccumsDetails.totalACSMAmount,
            acsmremain: res.data.accumulator.familyAccumsDetails.acsmAccumsDetails.remainingACSMAmount,
            nsamet: res.data.accumulator.familyAccumsDetails.nsaAccumsDetails.usedNSAMet,
            nsaremain: res.data.accumulator.familyAccumsDetails.nsaAccumsDetails.remainingNSAAmount,
            barRange: percentnsa,
            barRangeYellow: percentascm,
            loader: false
          })
        } else {
          this.setState({ loader: false })
        }
      })
      .catch()
  }

  getFieldValueById = (dataArray, targetId) => {
    const match = dataArray.find(item => item.idcardField === targetId);
    
    // Target ID not found
    if (!match) return null;

    // Target found but fieldValue is empty
    return match.fieldValue || "-";
  }

  getAddonsData = () => {
    gethealthcard().then(resp => {
      let data = {
        memberSSN: resp.data.memberIdCardList[0].memberSSN,
        type: 'family'
      }
      getRxSimpleShareData(data).then(res => {
        this.setState(
          {
            addOnsObj: res
          },
          () => {
            let counterHealthTool = 0
            let counterRxSimpleShare = 0
            let counterRevive = 0
            this.state.addOnsObj && this.state.addOnsObj.forEach(item => {
              // counts[x] = (counts[x] || 0) + 1;
              counterHealthTool = (item.addon.includes("Health Tools")  && item.status === 'AC') ? counterHealthTool + 1 : counterHealthTool
              counterRxSimpleShare = (item.addon.includes('RxSimpleShare')  && item.status === 'AC')? counterRxSimpleShare + 1 : counterRxSimpleShare
              counterRevive = (item.addon.includes('UHSRx')  && item.status === 'AC')? counterRevive + 1 : counterRevive
            })

            let findRxSimpleData = res && res.find(obj => (obj.addon.includes("RxSimpleShare"))&& obj.status === 'AC')
            let findHealToolData = res && res.find(obj => (obj.addon.includes("Health Tools")) && obj.status === 'AC')
            let findRevive = res && res.find(obj => (obj.addon.includes("UHSRx")) && obj.status === 'AC')
            if (findRxSimpleData) {
              this.setState({
                rxSimpleShareActive: true,
                counterRxSimpleShare: counterRxSimpleShare
              })
            }
            if (findHealToolData) {
              this.setState({
                healthToolAddonActive: true,
                counterHealthTool: counterHealthTool
              })
            }
            if (findRevive) {
              this.setState({
                reviveAddonActive: true,
                counterRevive: counterRevive
              })
            }
          }
        )
      })
    })
  }

  getEnrolledMemberData = () => {
    getEnrolledMemberData().then(res => {
      if (res && res.data) {
        this.setState({
          enrolledDataMember: res.data
        })
      }
    })
  }

  jumpToAddons() {
    let url = window.location.href
    if (url.split('ProgramInformation?').length > 1) {
      let queryString = url.split('ProgramInformation?')[1]
      let queryParams = new URLSearchParams(queryString)
      let addons = decodeURI(queryParams.get('change_addons'))
      if (addons === 'true') {
        this.changeProgram()
      } else {
        this.updateHousehold()
      }
      this.props.history.replace('/ProgramInformation')
    }
  }
  getCardEnable = () => {
    let client_id = localStorage.getItem('CLIENT_ID')

    getCardEnableData(client_id, 'ProgramInformation').then(res => {
      if (res.data.response.enable == 'false' || res.data.response.enable == false) {
        window.location.href = '/'
      }
    })
  }

  getSourceIDbyemail() {
    getSourceID().then(res => {
      this.agentInfoget(res.data.memberIdSource)
      this.getEnrollMember(res.data.memberIdSource)
    })
  }

  agentInfoget(sourceid) {
    if (sourceid) {
      getAgentInfo(sourceid).then(res => {
        if (res.data.response) {
          this.setState({
            agentemail: res.data.response.email,
            agentname: res.data.response.name,
            agentno: res.data.response.phone,
            brokerId: res.data.response.brokerId
          })
        } else {
        }
      })
    }
  }
  getEnrollMember = memberId => {
    getEnrollMemberInfoById(memberId).then(response => {
      if (response && response.data.response) {
        this.setState({ subID: response.data.response.subId, loader: false }, () => {
          this.jumpToAddons()
        })
      } else {
        this.setState({ loader: false }, () => {
          this.jumpToAddons()
        })
      }
    })
  }

  changeProgram = () => {
    let obj = {
      clientId: this.state.clientName,
      associationId: this.state.associationId,
      brokerId: this.state.brokerId,
      fromMember: true,
      isSelectProgram: true,
      user_subId: localStorage.getItem('userMail'),
      memberId: localStorage.getItem('sourceid'),
      subID: this.state.subID
    }
    if (this.state.subID === null || this.state.subID === undefined || this.state.subID === '') {
      this.setState({
        errorModal: true
      })
    } else {
      let windowReference = window.open()
      getEncryptData(obj).then(response => {
        let URL = process.env.REACT_APP_LOGIN_ENROLLMENT + 'login#state=' + response.data.response
        windowReference.location = URL
      })
    }
  }

  updateHousehold = () => {
    let obj = {
      clientId: this.state.clientName,
      associationId: this.state.associationId,
      brokerId: this.state.brokerId,
      fromMember: true,
      user_subId: localStorage.getItem('userMail'),
      isHouseholdUpdate: true,
      memberId: localStorage.getItem('sourceid'),
      subID: this.state.subID,
      isEditCensus: false
    }
    if (this.state.subID === null || this.state.subID === undefined || this.state.subID === '') {
      this.setState({
        errorModal: true
      })
    } else {
      let windowReference = window.open()
      getEncryptData(obj).then(response => {
        let URL = process.env.REACT_APP_LOGIN_ENROLLMENT + 'login#state=' + response.data.response

        windowReference.location = URL
      })
    }
  }

  goBack = () => {
    this.props.history.push('/')
  }


   handleBackClick = () => {
    if (this.props.onBackClick) {
      this.props.onBackClick()
    } else {
      window.history.back()
    }
  }


  handleProfileClick = event => {
  this.setState({
    profileAnchorEl: event.currentTarget,
    profileMenuOpen: true
  })
}

handleProfileMenuClose = () => {
  this.setState({
    profileMenuOpen: false
  })
}

handleProfileSettings = () => {
  this.handleProfileMenuClose();
  
  const sourceid = localStorage.getItem("sourceid");
  const subscriberName = localStorage.getItem('fullname');
  const email = localStorage.getItem('userMail');
  const nameParts = subscriberName.trim().split(' ');
  const firstName = nameParts[0] || '';
  const lastName = nameParts.slice(1).join(' ') || '';
  
  const profileConfig = {
    type: "profile_settings",
    firstName: firstName,
    lastName: lastName,
    email: email,
    phone: localStorage.getItem('phone') || '',
  };
  
  // Try to call the plugin function with retry logic
  const attemptProfileLoad = (retries = 0) => {
    // Check if function exists on window
    if (typeof window.loadCommonPluginScreen === 'function') {
      try {
        window.loadCommonPluginScreen(sourceid, profileConfig);
        console.log('Profile settings opened successfully');
      } catch (error) {
        console.error('Error calling loadCommonPluginScreen:', error);
        alert('An error occurred while opening profile settings.');
      }
    } else if (retries < 5) {
      setTimeout(() => attemptProfileLoad(retries + 1), 300);
    } else {
      console.error('Plugin function loadCommonPluginScreen not available after retries');
    }
  };
  
  attemptProfileLoad();
}
handleLogout = () => {
  localStorage.clear()
  sessionStorage.clear()
  window.location.href = '/login'
}

  handleCloseErrorModal = () => {
    this.setState({
      errorModal: false
    })
  }
  selectTab=(newValue)=>{
    this.setState({selectedTab: newValue})
  }
  render() {
    return (
      <div className="progInfoMainWrapper">
        {this.state.loader ? <CommonLoader /> : null}

        <div className="mobileViewHeader">
          <div className="mobile_header">
            <Link to="/">
              <ArrowBackIcon style={{ width: '24px', height: '24px', color: '#2e3192' }} />
            </Link>
            <div className="mobile_header_title">Program Information </div>

             <div className="appsicon_cursor" >
                        <IconButton onClick={this.handleProfileClick}>
                          <AccountCircleIcon style={{ color: '#8283be' }} />
                        </IconButton>
                        <Menu
                          anchorEl={this.state.profileAnchorEl}
                          open={this.state.profileMenuOpen}
                          onClose={this.handleProfileMenuClose}
                          style={{zIndex: 1000000}}
                        >
                          {localStorage.getItem('SOURCE') !== 'NEO' && (
                                      <MenuItem onClick={this.handleProfileSettings}>Profile Settings</MenuItem>
                          )}
                          <MenuItem onClick={this.handleLogout}>Sign Out</MenuItem>
                        </Menu>
                      </div>
          </div>
        </div>

        <div className="webHeader">
          <Header name={'Program Information'} />
        </div>

        <div className="container progInfoContainer">
          <sapn className="Back_page" onClick={this.goBack}>
            <ArrowBackIcon style={{ width: '24px', height: '24px', color: ' #2e3192', marginRight: '5px' }} onClick={this.goBack} />
            BACK
          </sapn>

          <div className="commonWrap" style={{paddingTop:"40px"}}>
            <ProgramInfoCard state={this.state} selectTab={(newValue) => this.selectTab(newValue)} />
              {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') &&
            <Tooltip placement="top" arrow title="Chat with a Universal Health Fellowship Representative">
                                        <CrudButton
                                          className={'purechat-button-expand'}
                                          color="primary"
                                          onClick={() => window.pureChat()}
                                          aria-label="add"
                                          style={{
                                              width: '65px',
                                              height: '65px',
                                              backgroundColor : "#ed1c24",
                                              color: '#ffffff',
                                              borderRadius: '50%',
                                              border: "none",
                                              position: 'fixed',
                                              right: '40px',
                                              bottom: '40px',
                                              zIndex: 109,
                                          }}
                                        >
                                        <ForumIcon />
                                       </CrudButton>
                           </Tooltip>}
          </div>
          <div className="mobileFooter">
            <div style={{ bottom: '9vh', paddingBottom:
                    this.state.selectedTab==="summary"|| this.state.selectedTab==="enrolledMembers" || this.state.selectedTab==="addOns"?
                      "15vh":"7vh"
                  }}>
              <ChatIcon 
                shiftup={ this.state.selectedTab==="enrolledMembers" || this.state.selectedTab==="addOns"? true : false} 
                changeProgram={this.state.selectedTab==="summary"? true:false}
                showAIChatIcon={true} />
              <div>
                <ChatIcon setAI={() => this.setState({ isAI: true })} />
              </div>
              <div>
                <MobCopyright />
              </div>
            </div>
          </div>
          <div className="fixed-bottom" style={{ visibility: window.mobileAndTabletCheck() ? '' : 'hidden' }}>
            <MobileFooter />
          </div>
        </div>

        <div className="webfooterNew">
          <CommonFooter />
        </div>

        {/* ===============================Error Modal====================================== */}

        <Modal size="small" show={this.state.errorModal} onHide={this.handleCloseErrorModal} centered backdrop="static">
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
            <IconButton aria-label="close" onClick={this.handleCloseErrorModal} style={{ marginTop: '-13px' }}>
              <CloseIcon />
            </IconButton>
          </Modal.Header>

          <Modal.Body>
            <b> {i18n.t('PROGRAM_INFORMATION_ERROR_MESSAGE.SUBID_MISSING')}</b>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseErrorModal} class="ButtonBG">
              OK
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal1 visible={this.state.isAI} width="90%" effect="fadeInUp">
          <div style={{ width: '90vw' }}>
            <div class="mqalert_modal_text">
              This service is currently offline. Please try again later.
            </div>
            <br />
            <div class="mqalert_button_div">
              <button className="mqalert_button" onClick={() => this.setState({ isAI: false })}>
                OK
              </button>
            </div>
          </div>
        </Modal1>
      </div>
    )
  }
}
export default withRouter(ProgramInformation)

const names = ['James', 'Paul', 'John', 'George', 'Ringo']
const sampleData = [
  { id: 733, planId: '7006', idcardField: 'Telemedicine', fieldValue: '$0' },
  { id: 735, planId: '7006', idcardField: 'PCP Office Visit', fieldValue: '$35' },
  { id: 736, planId: '7006', idcardField: 'Urgent Care', fieldValue: '$100' },
  { id: 737, planId: '7006', idcardField: 'ER Visit', fieldValue: '$400' }
]

const ProgramInfoCard = props => {
  const tabInQuery = window.location.href.includes('changeDependants') ? 'enrolledMembers' : 'summary'
  const [selectedTab, setSelectedTab] = useState('summary')
  const [isSuccess, setIsSuccess] = useState(false)
  const [msgModal, setmsgModal] = useState(null)
  const [loader, setLoader] = useState(false)
  const history = useHistory()
  const [titleModal, setTitleModal] = useState('')
  console.log('--- -- -- -- ', props.state.programname);

  const openChat = () => {
    sessionStorage.setItem('chatwindow', true)
    history.push('/')
  }
  const selectTab =(newValue)=>{
    setSelectedTab(newValue)
    props.selectTab(newValue)
  }
  const handleButtonClick = (action) => {
    switch (action) {
      case 'CHANGE PROGRAM':
        setIsSuccess(true);
        setTitleModal('Change Program');
        setmsgModal(`To change your program, please call UHF member support at ${localStorage.getItem('CONTACT_NUMBER')}, Monday through Friday 8:00 am to 8:00 pm EST.`)
        break;
      case 'MANAGE ADD-ONS':
        setIsSuccess(true);
        setTitleModal('Manage Add-ons');
        setmsgModal(`To manage your add-ons, please call UHF member support at ${localStorage.getItem('CONTACT_NUMBER')}, Monday through Friday 8:00 am to 8:00 pm EST.`)
        break;
      case 'UPDATE HOUSEHOLD':
        setIsSuccess(true);
        setTitleModal('Update Household');
        setmsgModal(`To update your household, please call UHF member support at ${localStorage.getItem('CONTACT_NUMBER')}, Monday through Friday 8:00 am to 8:00 pm EST.`)
        break;
      default:
        console.log("Unknown action");
    }
  };
  return (
    <div className="progInfoSection" style={{ padding: 0 }}>
      <Box component="section" sx={{ p: 4, bgcolor: '#f6f9ff', borderRadius: 1 }}>
        {/* Header Section */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', lg: 'center' },
            gap: 3,
            mb: 5
          }}
        >
          <Typography
            variant="h3"
            style={
              deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false')
                ? {
                    fontWeight: 300,
                    color: '#333',
                    textTransform: 'uppercase',
                    letterSpacing: 2
                  }
                : {
                    display: 'none'
                  }
            }
          >
            Program Information
          </Typography>
        
          <Box
            sx={
              deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false')
                ? { display: 'flex', gap: 20 }
                : { display: 'flex', gap: 2, paddingTop: 20 }
            }
          >
            {['CHANGE PROGRAM', 'MANAGE ADD-ONS', 'UPDATE HOUSEHOLD'].map(text => {
              if ((text === 'MANAGE ADD-ONS' || text === 'CHANGE PROGRAM') && props.state.programname?.toLowerCase() === 'senior 65') {
                return null
              }
              return (
                <Button
                  key={text}
                  variant="outlined"
                  style={{
                    zIndex: 2,
                    borderRadius: '50px',
                    color: '#2e3192',
                    borderColor: '#2e3192',
                    fontWeight: 'bold',
                    px: 3,
                    py: 1,
                    borderWidth: 2,
                    '&:hover': {
                      borderWidth: 2,
                      bgcolor: '#2e3192',
                      color: '#fff'
                    }
                  }}
                  onClick={() => handleButtonClick(text)}
                >
                  {text}
                </Button>
              )
            })}
          </Box>
        </Box>

        {/* Stats Section */}
        <Grid container spacing={3} justifyContent="space-between" alignItems="flex-start">
          {props.state.programData?.map((item, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={index === 0 ? 1 : true}
              key={index}
              style={{
                minWidth: 180,
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Box gap={0.5} style={{ marginBottom: 0.5, display: 'flex' }}>
                <Typography style={{ color: '#7a7a7a', display: 'block', marginBottom: 0.5, fontSize: 14 }}>{item.label}</Typography>

                {item.tooltip && (
                  <Tooltip
                    title={item.tooltip || ''}
                    arrow
                    placement="top"
                    enterTouchDelay={0}
                    leaveTouchDelay={3000}
                  >
                    <IconButton size="small">
                      <InfoOutlinedIcon className="HelpOutlineIcon" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
              <Typography style={{ fontWeight: 500, color: '#212121', fontSize: 24 }}>{item.value}</Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ width: '100%' }}>
        <AntTabs
          variant="scrollable"
          value={selectedTab}
          onChange={(e, newValue) => selectTab(newValue)}
          textColor="rgba(255, 255, 255, 0.12)"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
          // variant="scrollable"
          id="tabs"
          style={{ width: '100%' }}
        >
          <Tab label="Summary" value="summary" style={{ textTransform: 'capitalize', color: '#333333', width: '20%' }} />
          {localStorage.getItem('CLIENT_ID') != '5742' && localStorage.getItem('CLIENT_ID') != '4599' && (
            <Tab
              label="Consultation Fees"
              value="eligibleServices"
              style={{ textTransform: 'capitalize', color: '#333333', width: '30%' }}
            />
          )}
          {localStorage.getItem('CLIENT_ID') != '5742' && localStorage.getItem('CLIENT_ID') != '4599' && (
            <Tab label="Expense Limits" value="expenseLimits" style={{ textTransform: 'capitalize', color: '#333333', width: '20%' }} />
          )}
          <Tab
            label={
              localStorage.getItem('CLIENT_ID') == '5742' || localStorage.getItem('CLIENT_ID') == '4599' ? 'UHS Health Tools' : 'Add-ons'
            }
            value="addOns"
            style={{ textTransform: 'capitalize', color: '#333333', width: '20%' }}
          />
          {localStorage.getItem('CLIENT_ID') != '5742' && localStorage.getItem('CLIENT_ID') != '4599' && (
            <Tab label="Enrolled Members" value="enrolledMembers" style={{ textTransform: 'capitalize', color: '#333333', width: '20%' }} />
          )}
        </AntTabs>

        {selectedTab === 'summary' && <SummaryTabContent props={props} />}
        {selectedTab === 'eligibleServices' && <EligibleServiceTabContent props={props} />}
        {selectedTab === 'expenseLimits' && <ExpenseLimitTabContent props={props} />}
        {selectedTab === 'addOns' && <AddOnsTabContent props={props} />}
        {selectedTab === 'enrolledMembers' && <EnrolledMembersTabContent props={props} />}
      </Box>
      <Modal size="small" show={isSuccess} onHide={() => setIsSuccess(false)} centered backdrop="static">
        <Modal.Header>
          <Modal.Title className="modeltitlestyle">{titleModal}</Modal.Title>
          <IconButton aria-label="close" onClick={() => setIsSuccess(false)} style={{ marginTop: '-20px' }}>
            <CloseIcon />
          </IconButton>
        </Modal.Header>

        <Modal.Body>
          {loader ? <CommonLoader /> : null}
          <b>
            <span style={{ fontSize: '16px', fontWeight: '500' }}>{msgModal}</span>
          </b>
        </Modal.Body>

        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button variant="secondary" onClick={() => setIsSuccess(false)} class="ButtonBG">
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

const format = n => {
    n = Math.round(Number(n));   // round off
    return n.toLocaleString();
  }

const SummaryTabContent = ({ props }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [msgModal, setmsgModal] = useState(null)
  const [loader, setLoader] = useState(false)

  const openModal = () => setIsSuccess(true);
  const closeModal = () => setIsOpen(false)
  const closeSuccessModal = () => setIsSuccess(false)
  const isSmartShare = localStorage.getItem('NETWORK_NAME')?.toLowerCase().includes('smartshare');
  
  const isAcsmZero = 
    (props.state.acsmmet === 0 && props.state.acsmremain === 0 && props.state.acsmTotal === 0) ||
    (props.state.acsmmet === 0.0 && props.state.acsmremain === 0.0 && props.state.acsmTotal === 0.0);

  const showNsa = !isSmartShare;
  const showAcsm = !isAcsmZero;

  const setModalValue = val => {
    if (val == 'PROCEED') {
      setLoader(true)
      let obj1 = {
        Subject: localStorage.getItem('sourceid'),

        Origin: 'External',

        External_Application_Name__c: 'Member Portal',

        Status: 'New',

        Type: 'Account Update',

        SuppliedEmail: localStorage.getItem('userMail'),

        Description: 'Request to change'
      }

      let url = process.env.REACT_APP_BASE_URL + 'v1/memberportal/caseCreation'

      axios
        .post(url, obj1, {
          headers: {
            Authorization: 'Bearer' + ' ' + localStorage.getItem('bearerToken')
          }
        })
        .then(response => {
          if (response.data.success == 'true' || response.data.success == true) {
            setmsgModal('PROCEED')
            setIsOpen(false)
            setIsSuccess(true)
            setLoader(false)
          }
          // this.setState({errorModal:true,open:false,loader:false,MsgModal:'Request send successfully!'})
        })
    }
    if (val == 'CANCEL') {
      setLoader(true)
      setmsgModal('CANCEL')
      setIsOpen(false)
      // setIsSuccess(true)
      setLoader(false)
    }
    // setIsOpen(false)
  }

  let gridUrl = ''

  const getDescription = (planName) => {
    if (planName == 'UHS1' || planName == 'UHS2' || planName == 'UHS3' || planName == 'UHS4' || planName == 'UHS5' || planName == 'UHS6') {
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Standard-(UHS-1-3-5-6)-Program-Grid.pdf"
      return "UHS 1-6 (UHS1, UHS2, UHS3, UHS4, UHS5, and UHS6) are health cost sharing programs where you and your fellow members of Universal Health Fellowship share eligible medical expenses with each other. The programs include varying monthly contributions, on-site per-visit consultation fees, non-sharable amounts, waiting periods before sharing can begin, annual sharing limits, and sharing amounts and percentages. Eligible medical costs are shared on a per person per medical incident basis for illnesses or injuries incurring medical expenses that are medically necessary and provided by or under the direction of licensed Physicians within the Multiplan/PHCS Practitioner and Ancillary Network."
    } else if (planName == 'UHS SmartShare') {
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-SmartShare-Program-Grid.pdf"
      return 'UHS SmartShare programs are health cost sharing programs where you and your fellow members of Universal Health Fellowship share eligible medical expenses with each other. The SmartShare program includes a monthly contribution, on-site per-visit consultation fees, waiting periods before sharing can begin, annual sharing limits, and sharing amounts and percentages. There are no annual non-sharable amounts with this program. Eligible medical costs are shared on a per person per medical incident basis for illnesses or injuries incurring medical expenses that are medically necessary and provided by or under the direction of licensed Physicians within the Multiplan/PHCS Practitioner and Ancillary Network.'
    } else if (planName == 'THS50' || planName == 'THS75' || planName == 'THS100') {
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Thrive-HealthShare-Program-Grid.pdf"
      return 'UHS Thrive HealthShare programs are health cost sharing programs where you and your fellow members of Universal Health Fellowship share eligible medical expenses with each other. The Thrive HealthShare programs include monthly contributions, on-site per-visit consultation fees, waiting periods before sharing can begin, annual sharing limits, and sharing amounts and percentages. There are a set of annual non-sharable amounts (NSAs) with this program. But once the NSAs have been met, 100% of eligible medical expenses can be shared. Eligible medical costs are shared on a per person per medical incident basis for illnesses or injuries incurring medical expenses that are medically necessary and provided by or under the direction of licensed Physicians within the Multiplan/PHCS Practitioner and Ancillary Network.'
    } else if (planName == 'HL200' || planName == 'HL400' || planName == 'HL600') {
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf"
      return 'UHS HealthyLife programs are health cost sharing programs where you and your fellow members of Universal Health Fellowship share eligible medical expenses with each other. The HealthyLife program includes a monthly contribution, on-site per-visit consultation fees, waiting periods before sharing can begin, annual sharing limits, and sharing amounts and percentages. There are a set of annual non- sharable amounts with this program. Eligible medical costs are shared on a per person per medical incident basis for illnesses or injuries incurring medical expenses that are medically necessary and provided by or under the direction of licensed Physicians within the Multiplan/PHCS Practitioner and Ancillary Network.'
    } else if (planName == 'HLC200' || planName == 'HLC400' || planName == 'HLC600') {
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Healthy-Life-Program-Grid.pdf"
      return 'UHS HealthyLife programs are health cost sharing programs where you and your fellow members of Universal Health Fellowship share eligible medical expenses with each other. The HealthyLife program includes a monthly contribution, on-site per-visit consultation fees, waiting periods before sharing can begin, annual sharing limits, and sharing amounts and percentages. There are a set of annual non- sharable amounts with this program. Eligible medical costs are shared on a per person per medical incident basis for illnesses or injuries incurring medical expenses that are medically necessary and provided by or under the direction of licensed Physicians within the Multiplan/PHCS Practitioner and Ancillary Network.'
    } else if (planName == 'ES1' || planName == 'ES2' || planName == 'ES3') {
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-EssentialShare-Program-Grid.pdf"
      return 'UHS EssentialShare programs are health cost sharing programs where you and your fellow members of Universal Health Fellowship share eligible medical expenses with each other. The EssentialShare programs include monthly contributions, waiting periods before sharing can begin, annual sharing limits, and sharing amounts and percentages. There are no annual non-sharable amounts with this program. UHS EssentialShare is a limited sharing program that shares only up to a pre-determined amount, regardless of total charges incurred. There are no consultation fees or co-pays with this program, but you are responsible for any remaining billed charges from the provider. EssentialShare allows you to either use a provider in the Multiplan/PHCS Practitioner and Ancillary Network to take advantage of the reduced network price – or you can go to any provider you choose.'
    } else if (planName == 'CHS200' || planName == 'CHS400' || planName == 'CHS600' ) {
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Community-HealthShare-Program-Grid.pdf"
      return 'UHS Community HealthShare programs are health cost sharing programs where you and your fellow members of Universal Health Fellowship share eligible medical expenses with each other. The Community HealthShare programs include monthly contributions, on-site per-visit consultation fees, waiting periods before sharing can begin, annual sharing limits, and sharing amounts and percentages. There are a set of annual non-sharable amounts with this program. Eligible medical costs are shared on a per person per medical incident basis for illnesses or injuries incurring medical expenses that are medically necessary and provided by or under the direction of licensed Physicians within the Multiplan/PHCS Practitioner and Ancillary Network. Community HealthShare also includes the prescription program Rx SImpleShare and the Health Tools add-on featuring vision and dental discounts, as well as counseling from a telephonic health advocate service.'
    } else if (planName == 'PRS50' || planName == 'PRS75' || planName == 'PRS100' ) {
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Prosper-Program-Grid.pdf"
      return 'UHS Prosper programs are health cost sharing programs where you and your fellow members of Universal Health Fellowship share eligible medical expenses with each other. The Prosper program includes a monthly contribution, on-site per-visit consultation fees, waiting periods before sharing can begin, annual sharing limits, and sharing amounts and percentages. There are a set of annual non- sharable amounts with this program. Eligible medical costs are shared on a per person per medical incident basis for illnesses or injuries incurring medical expenses that are medically necessary and provided by or under the direction of licensed Physicians within the Multiplan/PHCS Practitioner and Ancillary Network.'
    } else if(planName.toLowerCase() == 'senior 65'){
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Senior-65-Welcome-Booklet-(Phase-1).pdf"
      return 'Senior 65 is a UHS health cost sharing supplement to Medicare coverage for UHF members aged 65-74. With an annual NSA (non-shareable amount) of just $500, members enrolled in Senior 65 can share their eligible medical expenses from any provider, facility, or hospital that accepts Medicare. Eligible medical costs are shared on a per person per medical incident basis for illnesses or injuries incurring medical expenses that are medically necessary and provided by or under the direction of licensed Physicians. Senior 65 also includes free telemedicine, UHF / Curam Wellness Center access, behavioral health counseling, and dental and vision discounts.<br><br>UHS Health Tools is included for all members in the Senior 65 Program. UHS Health Tools includes three programs – Coast to Coast Vision, AETNA Dental, and Telephonic Health Advocate. All three are available for you to use. For more information, please call 888-308-0024.'
    } else if(planName.toLowerCase() == 'stx1' || planName.toLowerCase() == 'stx2'){
      gridUrl = "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-STx-Program-Grid.pdf"
      return 'UHS ST<sub>x</sub>&nbsp; are health cost sharing programs where you and your fellow members of Universal Health Fellowship share eligible medical expenses with each other. The ST<sub>x</sub>&nbsp; programs include varying monthly contributions, on-site per-visit consultation fees, non-sharable amounts, waiting periods before sharing can begin, annual sharing limits, and sharing amounts and percentages. Eligible medical costs are shared on a per person per medical incident basis for illnesses or injuries incurring medical expenses that are medically necessary and provided by or under the direction of licensed Physicians within the Multiplan/PHCS Practitioner and Ancillary Network.'
    }
  }

  const renderProgramName = (programName) => {
    const name = programName.toLowerCase();
    if (name === 'stx1') return <>ST<sub>x</sub>1</>;
    if (name === 'stx2') return <>ST<sub>x</sub>2</>;
    return programName;
  };

  const viewBrochure = () => {
    window.open(gridUrl)
  }

  const shouldRenderSummary = (props.state.programname == 'ES1' || props.state.programname == 'ES2' || props.state.programname == 'ES3') ? !!props.state.nsamet : !!props.state.programname;

  const formatToTitleCase = (str) => {
      if (!str) return '';
      return String(str)
          .trim()
          .toLowerCase()
          .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div className="row sumary">
      <div className="col-12 col-md-5" style={{ margin: '0px 0px 30px 0px' }}>
        <div className="logoFont UHS6">
          {renderProgramName(props.state.programname)} <br></br>
          {props.state.showwithacsm ? <text className="ACSM">{props.state.programname2}</text> : null}
        </div>
        <p style={{ fontFamily: 'Roboto', color: '#000', fontWeight: 400 }}>
          <div dangerouslySetInnerHTML={{ __html: getDescription(props.state.programname) }} />
        </p>
        {props.state.programname == 'HLC200' ||
        props.state.programname == 'HLC400' ||
        props.state.programname == 'HLC600' ? null : props.state.programname.toLowerCase() == 'senior 65' ? (
          <p style={{ color: '#2e3192', cursor: 'pointer', fontWeight: '400' }} onClick={() => viewBrochure()}>
            View Booklet
          </p>
        ) : (
          <p style={{ color: '#2e3192', cursor: 'pointer', fontWeight: '500' }} onClick={() => viewBrochure()}>
            View Brochure
          </p>
        )}
      </div>
      <div className="col-12 col-md-7 headerSumary" 
            style={{
              overflowX: window.innerWidth < 768 ? 'auto' : 'visible',
              width: '100%',
            }}>
         <div style={{ minWidth: window.innerWidth < 768 ? '500px' : 'auto', }}>
        {shouldRenderSummary && (showNsa || showAcsm) ? (
          <Box style={{ width: '100%', maxWidth: 1000, mx: 'auto', p: 2, display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {/* ==================== ROW 1: HEADERS ==================== */}
            <Box className='gridLayoutStyles'>
              <div />
              {showNsa ? (
                <Typography
                  className="barTitle"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    fontSize: '0.95rem',
                    color: '#454d58'
                  }}
                >
                  Non-Sharable Amount (NSA)
                  <Tooltip
                    title="This is the amount you pay out of pocket before UHF begins sharing your medical bills."
                    arrow
                    placement="top"
                    enterTouchDelay={0}
                    leaveTouchDelay={3000}
                  >
                    <InfoOutlinedIcon className="HelpOutlineIcon" />
                  </Tooltip>
                </Typography>
              ) : (
                <div />
              )}

              {showAcsm ? (
                <Typography
                  className="barTitle"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    fontSize: '0.95rem',
                    color: '#454d58'
                  }}
                >
                  Annual Co-Share Maximum Amount (ACSM)
                  <Tooltip
                    title="After meeting your Personal Responsibility Amount (NSA), you and the sharing community split eligible costs. The Annual Co-Share Maximum caps what you'll pay in that split for the year. Once you reach it, your eligible expenses are shared at 100% for the rest of your program year."
                    arrow
                    placement="top"
                    enterTouchDelay={0}
                    leaveTouchDelay={3000}
                  >
                    <InfoOutlinedIcon className="HelpOutlineIcon" />
                  </Tooltip>
                </Typography>
              ) : (
                <div />
              )}
            </Box>
            <Box style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {/* ==================== ROW 2: HOUSEHOLD ==================== */}
              <Box className="gridLayoutStyles" style={{ mb: '4px' }}>
                <Typography style={{ fontWeight: '500', color: '#000' }}>Household</Typography>

                {showNsa ? (
                  <Box style={{marginTop:4}}>
                    <div className="progressContainer">
                      <div className="progressIndicator" style={{ width: `${props.state.barRange}%` }}>
                        <ArrowRightAltIcon viewBox="0 6 24 24" style={{ color: '#ffffff' }} />
                      </div>
                    </div>
                    <Box display="flex" justifyContent="space-between" mt={0.5}>
                      <Typography className="metAmt" style={{ fontWeight: 500, fontSize: '1rem' }}>
                        ${format(props.state.nsamet)} <span style={{ fontSize: '0.9rem' }}>met</span>
                      </Typography>
                      <Typography className="remainingAmt" style={{ fontWeight: 500, fontSize: '1rem' }}>
                        ${format(props.state.nsaremain)} <span style={{fontSize: '0.9rem' }}>remaining</span>
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <div />
                )}

                {showAcsm ? (
                  <Box style={{marginTop:4}}>
                    <div className="progressContainerYellow">
                      <div className="progressIndicatorYellow" style={{ width: `${props.state.barRangeYellow}%` }}>
                        <ArrowRightAltIcon viewBox="0 6 24 24" style={{ color: '#ffffff' }} />
                      </div>
                    </div>
                    <Box display="flex" justifyContent="space-between" mt={0.5}>
                      <Typography className="metAmt" style={{ fontWeight: 500, fontSize: '1rem' }}>
                        ${format(props.state.acsmmet)} <span style={{ fontSize: '0.9rem' }}>met</span>
                      </Typography>
                      <Typography className="remainingAmt" style={{fontWeight: 500, fontSize: '1rem' }}>
                        ${format(props.state.acsmremain)} <span style={{ fontSize: '0.9rem' }}>remaining</span>
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <div />
                )}
              </Box>

              {/* ==================== ROW 3: MEMBER 1 (JOHN DOE) ==================== */}
              {props.state.accumulator?.memberAccumsDetails.map((item, index) => (
                <Box className="gridLayoutStyles" key={index}>
                  <Typography style={{ color: '#000', fontWeight: 500,fontSize:'1rem' }}>{formatToTitleCase(item.memberName)}</Typography>

                  {showNsa ? (
                    <Box display="flex" justifyContent="space-between" style={{ color: '#454d58',fontSize:'.9rem' }}>
                      <Typography variant="body2" style={{ fontWeight: 500}}>${format(item.nsaAccumsDetails.usedNSAMet)} met</Typography>
                      <Typography variant="body2">
                        ${format(item.nsaAccumsDetails.remainingNSAAmount)} remaining
                      </Typography>
                    </Box>
                  ) : (
                    <div />
                  )}

                  {showAcsm ? (
                    <Box display="flex" justifyContent="space-between" style={{ color: '#454d58',fontSize:'.9rem' }}>
                      <Typography variant="body2" style={{ fontWeight: 500}} >${format(item.acsmAccumsDetails.usedAcsmMet)} met</Typography>
                      <Typography variant="body2">
                        ${format(item.acsmAccumsDetails.remainingAcsmAmount)} remaining
                      </Typography>
                    </Box>
                  ) : (
                    <div />
                  )}
                </Box>
              ))}
            </Box>
          </Box>
        ) : null}
        </div>
      </div>
      
      <Modal size="small" show={isOpen} onHide={closeModal} centered backdrop="static">
        <Modal.Header>
          <Modal.Title>Message</Modal.Title>
          <IconButton aria-label="close" onClick={closeModal} style={{ marginTop: '-13px' }}>
            <CloseIcon />
          </IconButton>
        </Modal.Header>

        <Modal.Body>
          {loader ? <CommonLoader /> : null}
          <span style={{ fontSize: '16px', fontWeight: '500' }}>
            You can submit a request to change your membership program. Our Member Services team will get in touch with you at the earliest
            and guide you through the process.
          </span>
        </Modal.Body>

        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button variant="secondary" onClick={() => setModalValue('PROCEED')} class="ButtonBG">
            PROCEED
          </Button>
          <Button variant="secondary" onClick={() => setModalValue('CANCEL')} class="ButtonBG">
            CANCEL
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="small" show={isSuccess} onHide={closeSuccessModal} centered backdrop="static">
        <Modal.Header>
          <Modal.Title>Message</Modal.Title>
          <IconButton aria-label="close" onClick={closeSuccessModal} style={{ marginTop: '-13px' }}>
            <CloseIcon />
          </IconButton>
        </Modal.Header>

        <Modal.Body>
          {loader ? <CommonLoader /> : null}
          <b>
            {msgModal == 'PROCEED' ? (
              <span style={{ fontSize: '16px', fontWeight: '500' }}>Your request has been submitted.</span>
            ) : (
              <span style={{ fontSize: '16px', fontWeight: '500' }}>
                To change your program, please call UHF member support at {localStorage.getItem('CONTACT_NUMBER')}, Monday through Friday
                8:00 am to 8:00 pm EST.
                {/* {localStorage.getItem('CONTACT_NUMBER')} */}
                {/* <Member Services Email>. */}
              </span>
            )}
          </b>
        </Modal.Body>

        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button variant="secondary" onClick={closeSuccessModal} class="ButtonBG">
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

const EligibleServiceTabContent = ({ props }) => {
  console.log('00000000 - ', props.state.eligibleServices);
  return (
    <div className="row EligibleServiceTabContent">
      <div className="col-12 col-md-5">
        <div className="leftData">
            <div style={{ paddingBottom: '16px' }}>
              <div className="row">
                {props.state.eligibleServices &&
                  props.state.eligibleServices.map((col, index) => {
                    const isESProgram = ['ES1', 'ES2', 'ES3'].includes(
                      props.state.programname
                    );

                    // Skip "NA" values for ES programs
                    if (isESProgram && col.fieldValue === 'NA') {
                      return null;
                    }

                    const isTwoColumn = props.state.eligibleServices.length > 6;

                    return (
                      <div
                        key={index}
                        className={isTwoColumn ? "col-6" : "col-12"}
                        style={{ marginBottom: "20px" }}
                      >
                        <p className="label" dangerouslySetInnerHTML={{ __html: col.idcardField || "-" }}/>
                        <p
                          className="number"
                          dangerouslySetInnerHTML={{ __html: col.fieldValue || "-" }}
                        />
                      </div>
                    );
                  })}
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ExpenseLimitTabContent = ({ props }) => {
  return (
    <div className="row EligibleServiceTabContent" style={{height:window.mobileAndTabletCheck?"": ""}}>
      <div className="col-12 col-md-12">
        <div className="leftData">
          <div className="row">
                {props.state.expenseLimits &&
                  props.state.expenseLimits.map((col, index) => {
                    const isESProgram = ['ES1', 'ES2', 'ES3'].includes(
                      props.state.programname
                    );

                    // Skip "NA" values for ES programs
                    if (isESProgram && col.fieldValue === 'NA') {
                      return null;
                    }

                    const isTwoColumn = props.state.expenseLimits.length > 6;

                    return (
                      <div
                        key={index}
                        className={isTwoColumn ? "col-3" : "col-12"}
                        style={{ marginBottom: "20px" }}
                      >
                        <p className="label" dangerouslySetInnerHTML={{ __html: col.idcardField || "-" }}/>
                        <p
                          className="number"
                          dangerouslySetInnerHTML={{ __html: col.fieldValue || "-" }}
                        />
                      </div>
                    );
                  })}
              </div>
        </div>
      </div>
    </div>
  )
}

const AddOnsTabContent = ({ props }) => {
  const [isSuccess, setIsSuccess] = useState(false)
  const [loader, setLoader] = useState(false)

  const closeSuccessModal = () => setIsSuccess(false)

  const fetchData = () => {
    setIsSuccess(true)
    // if(localStorage.getItem('CLIENT_ID') == 5558 ||
    // localStorage.getItem('CLIENT_ID') == '5558'||
    // localStorage.getItem('CLIENT_ID') == 4386 ||
    // localStorage.getItem('CLIENT_ID') == '4386'||
    // localStorage.getItem('CLIENT_ID') == 5596 ||
    // localStorage.getItem('CLIENT_ID') == '5596'||
    // localStorage.getItem('CLIENT_ID') == 4397 ||
    // localStorage.getItem('CLIENT_ID') == '4397'||
    // localStorage.getItem('CLIENT_ID') == 5696 ||
    // localStorage.getItem('CLIENT_ID') == '5696'||
    // localStorage.getItem('CLIENT_ID') == 4390 ||
    // localStorage.getItem('CLIENT_ID') == '4390')
    // {
    //   setIsSuccess(true)
    // }else{
    // let obj = {
    //   clientId: props.state.clientName,
    //   associationId: props.state.associationId,
    //   brokerId: props.state.brokerId,
    //   fromMember: true,
    //   isSelectProgram: true,
    //   user_subId: localStorage.getItem('userMail'),
    //   memberId: localStorage.getItem('sourceid'),
    //   subID: props.state.subID
    // }
    // // if (props.state.subID === null || props.state.subID === undefined || props.state.subID === '') {
    // //   this.setState({
    // //     errorModal: true
    // //   })
    // // } else {
    // const windowReference = window.open()
    // getEncryptData(obj).then(response => {
    //   const URL = process.env.REACT_APP_LOGIN_ENROLLMENT + 'login#state=' + response.data.response
    //   windowReference.location = URL
    // })
    // }
  }

  const dateformat = date => {
    const enrollmentDate = getDateInUTC(date, true)
    let nowdate = getDateInUTC(new Date(), true)

    var day = moment(enrollmentDate).format('DD')

    var mon = moment(enrollmentDate).format('MM')

    var year = moment(enrollmentDate).format('YYYY')

    var date = mon + '/' + day + '/' + year

    var todayDate = moment(nowdate).format('MM/DD/YYYY')
    let hr = moment(enrollmentDate).format('hh')

    if (date !== todayDate) {
      return moment(date).format('MMM DD, YYYY')
    } else {
      if (hr == '00') {
        return moment(enrollmentDate).format('m') + 'mins'
      }
      if (hr > 12) {
        return moment(enrollmentDate).format('hh:mm A')
      } else {
        return moment(enrollmentDate).format('hh:mm A')
      }
    }
  }

  const getDateInUTC = (date, getInMillisecs) => {
    if (date) {
      let newDateTime = new Date(date)
      return new Date(newDateTime)
    }

    return date
  }  

  return (
    <div className="row addonsTab">
     { (localStorage.getItem('CLIENT_ID') != '5742' && localStorage.getItem('CLIENT_ID') != '4599') && !localStorage.getItem('isRevive') && <div className="col-12 col-md-6 paddingRXSimpleShare">
        {/* {props.state.showwithacsm ? <h1 className="logoFont RxSimpleShare">RxSimpleShare</h1> : null} */}

        
        <h1 className="logoFont RxSimpleShare" style={{ marginBottom: '15px' }}>
          RxSimpleShare
        </h1>

        <div className="col-12 col-md-10" style={{ paddingLeft: '0px' }}>
          {props.state.rxSimpleShareActive ? (
            <>
              <span className={'Program_status_button Active'}>Active</span>
              <div className="row" style={{ marginLeft: '0px' }}>
                <div className="col-12 col-md-12" style={{ paddingLeft: '0px' }}>
                  <p className="AddOnslabel">Add-On Monthly Fee</p>
                  <p className="AddOnsValue">
                  {
                      props.state.programname == 'HL200' || props.state.programname == 'HL400' || props.state.programname == 'HL600' ?
                      `$0`
                      :
                      `$${props.state.counterRxSimpleShare ? props.state.counterRxSimpleShare * 25 : 25}`
                    }
                    {/* ${props.state.counterRxSimpleShare ? props.state.counterRxSimpleShare * 25 : 25}{' '} */}
                    <span className="AddOnslabel"> (Family Total)</span>{' '}
                  </p>
                </div>
              </div>
              <div className="row" style={{ marginLeft: '0px' }}>
                <div className="col-7 col-md-7" style={{ paddingLeft: '0px' }}>
                  <p className="AddOnslabel">Members Enrolled</p>
                  {props.state.addOnsObj &&
                    props.state.addOnsObj.map((val, idx) => {
                      return (val.addon.includes('RxSimpleShare')) && val.status == 'AC' ? (
                        <div className="row" style={{ marginLeft: '0px' }}>
                          <p className="AddOnsValue">{`${val.prefix || ""} ${val.firstName} ${val.middleName || ""} ${val.lastName} ${val.suffix || ""}`}</p>
                        </div>
                      ) : null
                    })}
                </div>

                <div className="col-5 col-md-5" style={{ paddingLeft: '0px' }}>
                  <p className="AddOnslabel">Effective Date</p>

                  {props.state.addOnsObj &&
                    props.state.addOnsObj.map((val, idx) => {
                      return (val.addon.includes('RxSimpleShare')) && val.status == 'AC' ? (
                        <div className="row" style={{ marginLeft: '0px' }}>
                          <p className="AddOnsValue">{val.addOnEffectiveDate && moment(val.addOnEffectiveDate).format("MMM, DD YYYY")}</p>
                        </div>
                      ) : null
                    })}
                </div>
              </div>
            </>
          ) : (
            <>
              <span className={'Program_status_button DECLINED'}>Inactive</span>
              <div className="row" style={{ marginLeft: '0px' }}>
                <div className="col-12 col-md-12" style={{ paddingLeft: '0px' }}>
                  <p className="AddOnslabel">Add-On Monthly Fee</p>
                  <p className="AddOnsValue">
                    $25 <span className="AddOnslabel">(Family Total)</span>{' '}
                  </p>
                </div>
              </div>
            </>
          )}
          <p className='addonDescription'>
            {props.state.programname == 'HLC200' || props.state.programname == 'HLC400' || props.state.programname == 'HLC600' ||
        props.state.programname == 'HL200' || props.state.programname == 'HL400' || props.state.programname == 'HL600' ?
            `Administered by Liviniti, RxSimpleShare provides access to over 60,000 licensed pharmacies that accept prescription orders from medical providers from the UHS RxSimpleShare Formulary. For Healthy Life members, there is a $5 co-share per prescription.`
        :`Administered by Liviniti, RxSimpleShare provides access to over 60,000 licensed pharmacies that accept prescription orders from medical providers from the UHS RxSimpleShare Formulary. Cost is $25 monthly and a $5 co-share per prescription.`}
          
          </p>
        </div>
      </div>}

      {/*------------UHSRx --------------*/}
      { (localStorage.getItem('CLIENT_ID') != '5742' && localStorage.getItem('CLIENT_ID') != '4599') && localStorage.getItem('isRevive') && <div className="col-12 col-md-6 paddingRXSimpleShare">
       
        <h1 className="logoFont RxSimpleShare" style={{ marginBottom: '15px' }}>
          UHSRx
        </h1>

        <div className="col-12 col-md-10" style={{ paddingLeft: '0px' }}>
          {props.state.reviveAddonActive ? (
            <>
              <span className={'Program_status_button Active'}>Active</span>
              <div className="row" style={{ marginLeft: '0px' }}>
                <div className="col-12 col-md-12" style={{ paddingLeft: '0px' }}>
                  <p className="AddOnslabel">Add-On Monthly Fee</p>
                  <p className="AddOnsValue">
                  {`$0`}
                    <span className="AddOnslabel"> (Family Total)</span>{' '}
                  </p>
                </div>
              </div>
              <div className="row" style={{ marginLeft: '0px' }}>
                <div className="col-7 col-md-7" style={{ paddingLeft: '0px' }}>
                  <p className="AddOnslabel">Members Enrolled</p>
                  {props.state.addOnsObj &&
                    props.state.addOnsObj.map((val, idx) => {
                      return (val.addon.includes('UHSRx')) && val.status == 'AC' ? (
                        <div className="row" style={{ marginLeft: '0px' }}>
                          <p className="AddOnsValue">{`${val.prefix || ""} ${val.firstName} ${val.middleName || ""} ${val.lastName} ${val.suffix || ""}`}</p>
                        </div>
                      ) : null
                    })}
                </div>

                <div className="col-5 col-md-5" style={{ paddingLeft: '0px' }}>
                  <p className="AddOnslabel">Effective Date</p>

                  {props.state.addOnsObj &&
                    props.state.addOnsObj.map((val, idx) => {
                      return (val.addon.includes('UHSRx')) && val.status == 'AC' ? (
                        <div className="row" style={{ marginLeft: '0px' }}>
                          <p className="AddOnsValue">{val.addOnEffectiveDate && moment(val.addOnEffectiveDate).format("MMM, DD YYYY")}</p>
                        </div>
                      ) : null
                    })}
                </div>
              </div>
            </>
          ) : (
            <>
              <span className={'Program_status_button DECLINED'}>Inactive</span>
              <div className="row" style={{ marginLeft: '0px' }}>
                <div className="col-12 col-md-12" style={{ paddingLeft: '0px' }}>
                  <p className="AddOnslabel">Add-On Monthly Fee</p>
                  <p className="AddOnsValue">
                    $0 <span className="AddOnslabel">(Family Total)</span>{' '}
                  </p>
                </div>
              </div>
            </>
          )}
          <p className='addonDescription'>
            {`Administered by Manifest Pharmacy (a ReviveHealth company), UHSRx provides access to over 1,000 no-cost medications available through mail order (chronic needs) and in-store pharmacy pickup (urgent needs) at over 70,000 retail pharmacies. Most prescriptions are filled with a 90-day supply. The UHSRX program is FREE to all UHF members.`}
          </p>
        </div>
      </div>}
      {/* -----------health tool data------------------ */}

      <div className={(localStorage.getItem('CLIENT_ID') == '5742' || localStorage.getItem('CLIENT_ID') == '4599') ? 'col-12 col-md-12' :"col-12 col-md-6"}>
        <div className="leftDataAddons">
          <div className="row" style={{ overflowY: 'auto' }}>
            <div className="col-12 col-md-12" style={{ paddingBottom: '16px' }}>
              <h1 className="logoFont RxSimpleShare" style={{ marginBottom: '15px' }}>
                {props.state.programname == 'ES1' || props.state.programname == 'ES2' || props.state.programname == 'ES3' ? 'Advanced ' : ''}Health Tools
              </h1>
              <div className="col-12 col-md-12" style={{ paddingLeft: '0px' }}>
                {props.state.healthToolAddonActive == true ? (
                  <>
                    <span className={'Program_status_button Active'}>Active</span>
                    {(localStorage.getItem('CLIENT_ID') == '5742' || localStorage.getItem('CLIENT_ID') == '4599') ? 
                    <></>
                    :<div className="row" style={{ marginLeft: '0px' }}>
                          <div className="col-12 col-md-12" style={{ paddingLeft: '0px' }}>
                            <p className="AddOnslabel">Add-On Monthly Fee</p>
                            <p className="AddOnsValue">
                              $25 <span className="AddOnslabel">(Family Total)</span>{' '}
                            </p>
                          </div>
                        </div>
                    }
                    <div className="row" style={{ marginLeft: '0px' }}>
                      <div className="col-7 col-md-6" style={{ paddingLeft: '0px' }}>
                        <p className="AddOnslabel">Members Enrolled</p>

                        {props.state.addOnsObj &&
                          props.state.addOnsObj.map((val, idx) => {
                            return (val.addon.includes("Health Tools")) && val.status == 'AC' ? (
                              <div className="row" style={{ marginLeft: '0px' }}>
                                <p className="AddOnsValue">{`${val.prefix || ""} ${val.firstName} ${val.middleName || ""} ${val.lastName} ${val.suffix || ""}`}</p>
                              </div>
                            ) : null
                          })}
                      </div>

                      <div className="col-5 col-md-5" style={{ paddingLeft: '0px' }}>
                        <p className="AddOnslabel">Effective Date</p>

                        {props.state.addOnsObj &&
                          props.state.addOnsObj.map((val, idx) => {
                            return (val.addon.includes("Health Tools")) && val.status == 'AC' ? (
                              <div className="row" style={{ marginLeft: '0px' }}>
                                <div className="col-12 col-md-6" style={{ paddingLeft: '0px' }}>
                                  <p className="AddOnsValue">{val.addOnEffectiveDate && moment(val.addOnEffectiveDate).format("MMM, DD YYYY")}</p>
                                </div>
                              </div>
                            ) : null
                          })}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <span className={'Program_status_button DECLINED'}>Inactive</span>
                    <div className="row" style={{ marginLeft: '0px' }}>
                      <div className="col-12 col-md-12" style={{ paddingLeft: '0px' }}>
                        <p className="AddOnslabel">Add-On Monthly Fee</p>
                        <p className="AddOnsValue">
                          $25 <span className="AddOnslabel">(Family Total)</span>{' '}
                        </p>
                      </div>
                    </div>
                  </>
                )}
                {props.state.programname == 'ES1' || props.state.programname == 'ES2' || props.state.programname == 'ES3' ?
                  <p className='addonDescription'>Advanced Health Tools is an Add-On to a UHS sharing program that includes five programs – Coast to
                    Coast Vision, AETNA Dental, Telephonic Health Advocate, FlexCare Telemedicine, and CuramLife
                    Concierge Service. All five are available to every member of the member’s immediate family, regardless
                    of which family members are enrolled in the UHS Sharing program.</p>
                  : props.state.programname.toLowerCase() == 'senior 65' ?
                  <p className='addonDescription'>
                    UHS Health Tools is included for all members in the Senior 65 Program. UHS Health Tools includes 
                    three programs – Coast to Coast Vision, AETNA Dental, and Telephonic Health Advocate. All three are 
                    available for you to use. For more information, please call 888-308-0024.
                  </p>
                  :<p className='addonDescription'>Health Tools is an Add-On to a UHS sharing program that includes three programs – Coast to Coast
                    Vision, AETNA Dental, and Telephonic Health Advocate. All three are available to every member of the
                    UHF member’s immediate family, regardless of which family members are enrolled in the UHS Sharing
                    program.</p>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}

const EnrolledMembersTabContent = ({ props }) => {
  const theme = createMuiTheme({
    MuiTableCell: {
      paddingLeft: '30px',
      borderBottom: 'none'
    }
  })

  const useRowStyles = makeStyles({
    root: {
      borderBottom: '0px',
      '& > *': {
        borderBottom: 'unset',
        color: 'red'
      }
    }
  })

  const classes = useRowStyles()
  const [isSuccess, setIsSuccess] = useState(false)
  const [loader, setLoader] = useState(false)

  const closeSuccessModal = () => setIsSuccess(false)
  
  const updateHousehold = () => {
    setIsSuccess(true);
    // if(
    //   localStorage.getItem('CLIENT_ID') == 5558 ||
    //             localStorage.getItem('CLIENT_ID') == '5558'||
    //             localStorage.getItem('CLIENT_ID') == 4386 ||
    //             localStorage.getItem('CLIENT_ID') == '4386'||
    //             localStorage.getItem('CLIENT_ID') == 5596 ||
    //             localStorage.getItem('CLIENT_ID') == '5596'||
    //             localStorage.getItem('CLIENT_ID') == 4397 ||
    //             localStorage.getItem('CLIENT_ID') == '4397'||
    //             localStorage.getItem('CLIENT_ID') == 5696 ||
    //             localStorage.getItem('CLIENT_ID') == '5696'||
    //             localStorage.getItem('CLIENT_ID') == 4390 ||
    //             localStorage.getItem('CLIENT_ID') == '4390'
    // ) {
  
    //   setIsSuccess(true);
    // }else{
    // let obj = {
    //   clientId: props.state.clientName,
    //   associationId: props.state.associationId,
    //   brokerId: props.state.brokerId,
    //   fromMember: true,
    //   user_subId: localStorage.getItem('userMail'),
    //   isHouseholdUpdate: true,
    //   memberId: localStorage.getItem('sourceid'),
    //   subID: props.state.subID,
    //   isEditCensus: false
    // }
    // let windowReference = window.open()
    // getEncryptData(obj).then(response => {
    //   let URL = process.env.REACT_APP_LOGIN_ENROLLMENT + 'login#state=' + response.data.response

    //   windowReference.location = URL
    // })
    // }

  }

  const dateformat = date => {
    const enrollmentDate = getDateInUTC(date, true)
    let nowdate = getDateInUTC(new Date(), true)

    var day = moment.utc(enrollmentDate).format('DD')

    var mon = moment.utc(enrollmentDate).format('MM')

    var year = moment.utc(enrollmentDate).format('YYYY')

    var date = mon + '/' + day + '/' + year

    var todayDate = moment(nowdate).format('MM/DD/YYYY')
    let hr = moment(enrollmentDate).format('hh')

    if (date !== todayDate) {
      return moment(date).format('MMM DD, YYYY')
    } else {
      if (hr == '00') {
        return moment(enrollmentDate).format('m') + 'mins'
      }
      if (hr > 12) {
        return moment(enrollmentDate).format('hh:mm A')
      } else {
        return moment(enrollmentDate).format('hh:mm A')
      }
    }
  }

  const getDateInUTC = (date, getInMillisecs) => {
    if (date) {
      let newDateTime = new Date(date)
      return new Date(newDateTime)
    }

    return date
  }
  return (
    <div style={{ backgroundColor: '#fcfcfc' }}>
      <div className={'enrolledTableClass '} style={{marginLeft:'40px'}}>
        <div className="enrolledTable">
        <Paper className={'tableContainer '}>
          <TableContainer style={{ height: 300, backgroundColor: '#fcfcfc' }}>
            <Table className="mainTable " aria-labelledby="tableTitle" size={'medium'} aria-label="enhanced table" stickyHeader>
              <TableBody>
                <ThemeProvider theme={theme}>
                  <TableRow className={classes.root}>
                    <TableCell style={{ padding: 0 }} colSpan={12}>
                      <Box>
                        <TableRow>
                          <TableHeadCell align="left" className="innerTh" style={{ width: '250px' }}>
                            Member Name
                          </TableHeadCell>
                          <TableHeadCell align="left" className="innerTh" style={{ width: '200px' }}>
                            Member ID
                          </TableHeadCell>
                          <TableHeadCell align="left" className="innerTh" style={{ width: '200px' }}>
                            Relationship
                          </TableHeadCell>

                          <TableHeadCell align="left" className="innerTh" style={{ width: '211px' }}>
                            Birth Date
                          </TableHeadCell>

                          <TableHeadCell align="left" className="innerTh" style={{ width: '200px' }}>
                            Birth Gender
                          </TableHeadCell>

                          <TableHeadCell align="left" className="innerTh" style={{ width: '200px' }}>
                            Effective Date
                          </TableHeadCell>
                          <TableHeadCell align="left" className="innerTh" style={{ width: '200px' }}>
                            Status
                          </TableHeadCell>
                        </TableRow>

                        <TableBody>
                          {props.state.enrolledDataMember &&
                            props.state.enrolledDataMember.map((val, idx) => {
                              return idx == 0 ? (
                                <TableRow className="MuiTableCellclass">
                                  <TableBodyCell style={{ fontWeight: 'bold' }}>Adult 1 {`${val.prefix || ""} ${val.firstName} ${val.middleName || ""} ${val.lastName} ${val.suffix || ""}`}</TableBodyCell>
                                  <TableBodyCell style={{ fontWeight: 'bolder', color: '#2e3192' }}>{val.memberId}</TableBodyCell>
                                  <TableBodyCell style={{ fontWeight: 'bolder' }}>
                                    {val.relationshipCd == '18' ? 'Self' : val.relationshipCd == '19' ? 'Child' : 'Spouse'}
                                  </TableBodyCell>
                                  <TableBodyCell style={{ fontWeight: 'bolder' }}>{dateformat(val.dateOfBirth)}</TableBodyCell>
                                  <TableBodyCell style={{ fontWeight: 'bolder' }}>{val.gender == 'F' ? 'Female' : 'Male'}</TableBodyCell>
                                  <TableBodyCell style={{ fontWeight: 'bolder' }}>
                                    {val.benefits.map(dt => {
                                      return dateformat(dt.benefitBegin)
                                    })}
                                  </TableBodyCell>
                                  {
                                    val.status == "AC" ?
                                    <TableBodyCell>
                                      <text style={customStyle.activeButton}>Active</text>
                                    </TableBodyCell>
                                    :
                                    <TableBodyCell>
                                      <text style={customStyle.terminatedButton}>Terminated</text>
                                    </TableBodyCell>
                                  }
                                </TableRow>
                              ) : (
                                <TableRow className="headClass">
                                  <TableBodyCell>
                                    Adult {idx + 1} {`${val.prefix || ""} ${val.firstName} ${val.middleName || ""} ${val.lastName} ${val.suffix || ""}`}
                                  </TableBodyCell>
                                  <TableBodyCell style={{ color: '#2e3192' }}>{val.memberId}</TableBodyCell>
                                  <TableBodyCell>
                                    {val.relationshipCd == '18' ? 'Self' : val.relationshipCd == '19' ? 'Child' : 'Spouse'}
                                  </TableBodyCell>
                                  <TableBodyCell>{dateformat(val.dateOfBirth)}</TableBodyCell>
                                  <TableBodyCell>{val.gender == 'F' ? 'Female' : 'Male'}</TableBodyCell>
                                  <TableBodyCell>
                                    {val.benefits.map(dt => {
                                      return dateformat(dt.benefitBegin)
                                    })}
                                  </TableBodyCell>
                                  {
                                    val.status == "AC" ?
                                    <TableBodyCell>
                                      <text style={customStyle.activeButton}>Active</text>
                                    </TableBodyCell>
                                    :
                                    <TableBodyCell>
                                      <text style={customStyle.terminatedButton}>Terminated</text>
                                    </TableBodyCell>
                                  }
                                </TableRow>
                              )
                            })}
                        </TableBody>
                      </Box>
                    </TableCell>
                  </TableRow>
                </ThemeProvider>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        </div>
      </div>   
    </div>
  )
}
